import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

export default function GameBox({ game, onClick }) {
  return (
    <Card
      sx={{
        width: 280,
        margin: 2,
        display: "flex",
        flexDirection: "column",
        height: 340,
        boxShadow: 3,
      }}
      aria-label={`Open ${game.title} game`}
    >
      <CardActionArea onClick={() => onClick(game.id)} sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <CardMedia
          component="img"
          height="180"
          image={game.thumbnail}
          alt={`${game.title} thumbnail`}
          loading="lazy"
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography gutterBottom variant="h6" component="h2" noWrap>
            {game.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ height: "4.5em", overflow: "hidden" }}>
            {game.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}